import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Form from 'flarum/common/components/Form';
import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import Stream from 'flarum/common/utils/Stream';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import TwoFactorCodeInput from './TwoFactorCodeInput';
export default class TwoFactorEnableModal extends Modal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "user", void 0);
    // Statuses: 'loading', 'displayQR', 'displayBackupCodes', 'final'
    _defineProperty(this, "status", 'loading');
    _defineProperty(this, "qrCodeUrl", null);
    _defineProperty(this, "backupCodes", []);
    _defineProperty(this, "token", void 0);
    _defineProperty(this, "code", null);
    _defineProperty(this, "activeTab", 'qrcode');
    _defineProperty(this, "loading", false);
    _defineProperty(this, "originalHide", void 0);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.user = this.attrs.user;
    this.token = Stream('');

    // Save the original hide method
    this.originalHide = this.hide.bind(this);

    // Override dismissibility based on forced mode for this instance
    if (this.attrs.forced) {
      // Override hide to prevent dismissal when forced, unless completed
      this.hide = () => {
        // Allow hiding only when completed (status === 'final')
        if (this.status === 'final') {
          this.originalHide();
        }
      };
    }
  }
  static get isDismissibleViaCloseButton() {
    return true;
  }
  static get isDismissibleViaEscKey() {
    return true;
  }
  static get isDismissibleViaBackdropClick() {
    return true;
  }
  className() {
    return 'TwoFactorEnableModal Modal--small';
  }
  title() {
    return app.translator.trans('ianm-twofactor.forum.security.two_factor_heading');
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    const userId = this.user.id();
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + "/users/".concat(userId, "/twofactor/qrcode")
    }).then(response => {
      this.qrCodeUrl = response.svg;
      this.code = response.code;
      this.status = 'displayQR';
      m.redraw();
    });
  }
  onupdate() {
    const tokenInput = document.querySelector('.TwoFactorEnableModal [name=token]');
    if (tokenInput && document.activeElement !== tokenInput) {
      tokenInput.focus();
    }
  }
  content() {
    return m("div", {
      className: "Modal-body"
    }, this.status === 'loading' && m("div", {
      className: "loading"
    }, m(LoadingIndicator, null), m("p", null, app.translator.trans('ianm-twofactor.forum.security.loading_qr'))), this.status === 'displayQR' && m("div", null, this.attrs.forced && m("div", null, m("p", null, app.translator.trans('ianm-twofactor.forum.user_2fa.alert_message'))), m("div", {
      className: "tabs"
    }, m(Button, {
      className: "TwoFactorModal-tab ".concat(this.activeTab === 'qrcode' ? 'active' : ''),
      onclick: () => {
        this.activeTab = 'qrcode';
        m.redraw();
      }
    }, app.translator.trans('ianm-twofactor.forum.security.qr_tab')), m(Button, {
      className: "TwoFactorModal-tab ".concat(this.activeTab === 'manual' ? 'active' : ''),
      onclick: () => {
        this.activeTab = 'manual';
        m.redraw();
      }
    }, app.translator.trans('ianm-twofactor.forum.security.manual_tab'))), this.activeTab === 'qrcode' && m("div", {
      className: "qrSection"
    }, m("img", {
      className: "qrImage",
      src: this.qrCodeUrl,
      alt: app.translator.trans('ianm-twofactor.forum.security.qr_code_alt')
    }), m("p", {
      className: "helpText"
    }, app.translator.trans('ianm-twofactor.forum.security.scan_qr_instruction'))), this.activeTab === 'manual' && m("div", {
      className: "manualEntrySection"
    }, m("code", {
      className: "manualEntryCode"
    }, this.code), m("p", {
      className: "helpText"
    }, app.translator.trans('ianm-twofactor.forum.security.manual_entry_instruction'))), m(Form, null, m("form", {
      onsubmit: this.onSubmit.bind(this)
    }, m("div", {
      className: "Form-group"
    }, m(TwoFactorCodeInput, {
      placeholder: app.translator.trans('ianm-twofactor.forum.security.enter_token'),
      initial: this.token(),
      onComplete: code => {
        this.token(code);
        this.verifyToken();
      }
    })), m("div", {
      className: "Form-group"
    }, m(Button, {
      type: "submit",
      className: "Button Button--primary",
      onclick: this.verifyToken.bind(this),
      loading: this.loading
    }, app.translator.trans('ianm-twofactor.forum.security.verify_button')))))), this.status === 'displayBackupCodes' && m("div", null, m("p", null, app.translator.trans('ianm-twofactor.forum.security.backup_codes')), m("ul", null, this.backupCodes.map(code => m("li", null, m("code", null, code)))), m("p", null, app.translator.trans('ianm-twofactor.forum.security.backup_codes_instruction')), m(Button, {
      className: "Button Button--primary",
      onclick: () => {
        this.status = 'final';
        m.redraw();
      }
    }, app.translator.trans('ianm-twofactor.forum.security.saved_backup_codes_button'))), this.status === 'final' && m("div", null, m("p", null, app.translator.trans('ianm-twofactor.forum.security.two_factor_enabled_confirmation')), m(Button, {
      className: "Button Button--primary",
      onclick: this.finish.bind(this)
    }, app.translator.trans('ianm-twofactor.forum.security.ok_button'))));
  }
  verifyToken() {
    this.loading = true;
    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/users/twofactor/verify',
      body: {
        token: this.token()
      }
    }).then(response => {
      const _ref = response,
        backupCodes = _ref.backupCodes;
      this.backupCodes = backupCodes;
      this.status = 'displayBackupCodes';
      m.redraw();
    }).catch(error => {
      app.alerts.show({
        type: 'error'
      }, app.translator.trans('ianm-twofactor.forum.security.verification_failed'));
    }).finally(() => {
      this.loading = false;
    });
  }
  finish() {
    var _this$attrs$onEnabled, _this$attrs;
    (_this$attrs$onEnabled = (_this$attrs = this.attrs).onEnabled) == null || _this$attrs$onEnabled.call(_this$attrs);
    this.hide();
  }
  onSubmit(e) {
    e.preventDefault();
    this.verifyToken();
  }
}
flarum.reg.add('ianm-twofactor', 'forum/components/TwoFactorEnableModal', TwoFactorEnableModal);